import { getJourneysByTerm, queryByFetch, getAdminToolList, upgradeJourney, importZip, uploadZip, getAdminToolVersion, getJourneyUpgradeLogging, checkJourneyIds, getJourneyEngineSettingsList } from './io';
import { Promise } from 'es6-promise';
import types from '../store/types';
import store from '../store/store';
import { IdHelper, IJourneyItem, IAdminToolPanel, AdminToolPanelHelper, EJourneyToolSearchType, JESettingsListData, IJESettingsSidebar } from './';
import { PANEL_VALUE_JESETTINGS_LIST, PANEL_VALUE_RESULT_LIST } from '../constants';
import { IPanelState } from 'office-ui-fabric-react';
declare var jQuery;

export class AdminToolHelper {
    /**
    * Get class name by upgradeMessageType id
    * @static
    * @memberOf AdminToolHelper
    */
    public static GetLogMessageStyle(upgradeMessageType: number) {
        let className: string = "";
        switch (upgradeMessageType) {
            case 0:
                className = "logmessage-success";
                break;
            case 1:
                className = "logmessage-error";
                break;
            case 2:
                className = "logmessage-warning";
                break;
            case 3:
                className = "logmessage-info";
                break;
        }
        return className;
    }
    /**
     * Update loggingTextArea box with latest value
     * @static
     * @memberOf AdminToolHelper
     */
    public static UpdateTextAreaLog(text: any) {
        let copyText: HTMLTextAreaElement = <HTMLTextAreaElement>document.getElementById("loggingTextArea");
        copyText.value = text;
    }
    /**
    * Copy textbox value into the clipboard
    * @static
    * @memberOf AdminToolHelper
    */
    public static CopyToClipboard(id: string) {
        type SelectableElement = HTMLTextAreaElement | HTMLInputElement;
        let copyText: SelectableElement = <SelectableElement>document.getElementById(id);
        copyText.select();
        document.execCommand("Copy");
    }
    /**
    *  Set the version of the admin tool in the state
    * @static
    * @memberOf AdminToolHelper
    */
    public static SetAdminToolSetting(advancedLogging?: boolean, version?: string) {
        store.dispatch({
            type: types.SET_UPGRADE_SETTINGS,
            version: version,
            advancedLogging: advancedLogging
        });
    }

    /**
    *  Add valid journeys to the process list state.
    * @static
    * @memberOf AdminToolHelper
    */
    public static AddJourneysToProcessListState(items: string[], panel: IAdminToolPanel, processList: IJourneyItem[]) {
        AdminToolPanelHelper.SetPanelIsLoading(panel.panelName, true);

        AdminToolHelper.ValidateJourneyGuids(items).then((response) => {
            let listJourneyItem: IJourneyItem[] = [];

            if (response.validJourneys) {
                response.validJourneys.forEach(item => {

                    let findJourney: IJourneyItem = processList.filter(a => a.journeyId == item.journeyId)[0];
                    if (!findJourney) {
                        listJourneyItem.push(item);
                    }
                });
            }
            AdminToolHelper.AddToProccessList(listJourneyItem);
            AdminToolPanelHelper.SetPanelIsLoading(panel.panelName, false);
        }, (error) => {
            AdminToolPanelHelper.AddErrorMessagesToState(panel, "Failed to add journeys to the journey list.Please try again.");
        });
    }
    /**
    * Get the logs from the server every 500ms until isProccessing is set to false
    * @static
    * @memberOf AdminToolHelper
    */
    public static GetLoggingFor(journeyId: string, upgradeId: string, getAdvancedLogging: boolean) {
        let promise = new Promise<any>((resolve, reject) => {
            getJourneyUpgradeLogging(journeyId, upgradeId, getAdvancedLogging).then(
                (response) => {

                    store.dispatch({
                        type: types.SET_PROCESSING_LOGGING,
                        loggingList: response
                    });
                    setTimeout(() => {
                        let getState: any = store.getState();
                        if (getState.adminToolState.isProccessing) {
                            AdminToolHelper.GetLoggingFor(journeyId, upgradeId, getState.adminToolState.advancedLogging);
                        }
                    }, 1000);

                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }

    /**
    * Get all active journeys and add them to the process item list
    * @static
    * @memberOf AdminToolHelper
    */
    public static AddAllJourneysToProcessList(processList: any, panel: IAdminToolPanel, eJourneyToolSearchType: EJourneyToolSearchType = null) {
        AdminToolHelper.GetJourneyByTerms(processList, "", false, eJourneyToolSearchType).then((response) => {
            let listJourneyItem: IJourneyItem[] = [];

            if (response) {
                response.forEach(item => {
                    if (!processList || !processList.filter(a => a.journeyId == item.journeyId)[0]) {
                        listJourneyItem.push(item);
                    }
                });
            }
            AdminToolHelper.AddToProccessList(listJourneyItem);
            AdminToolPanelHelper.SetPanelIsLoading(panel.panelName, false);
        },
            (error) => {
                AdminToolPanelHelper.AddErrorMessagesToState(panel, "Failed to add  all journeys to the journey list.Please try again.");
            });
    }

    /**
    * Get all active journeys and add them to the process item list
    * @static
    * @memberOf AdminToolHelper
    */
    public static AddAllJESettingsToProcessList(processList: any, panel: IAdminToolPanel, eJourneyToolSearchType: EJourneyToolSearchType = null) {
        AdminToolHelper.GetJourneyByTerms(processList, "", false, eJourneyToolSearchType).then((response) => {
            let jesettingsListData: JESettingsListData[] = [];

            if (response) {
                response.forEach(item => {
                    if (!processList || !processList.filter(a => a.journeyId == item.journeyId)[0]) {
                        jesettingsListData.push(item);
                    }
                });
            }
            AdminToolHelper.AddJESettingToProccessList(jesettingsListData);
            AdminToolPanelHelper.SetPanelIsLoading(panel.panelName, false);
        },
            (error) => {
                AdminToolPanelHelper.AddErrorMessagesToState(panel, "Failed to load all JE Settings to the process list. Please try again.");
            });
    }
    /**
    *  Fetchs the title and  the version foreach journey and then adds it to the process item list
    * @static
    * @memberOf AdminToolHelper
    */
    public static AddToProcessListWithTitles(items: string[], journeys: IJourneyItem[], panelName: string) {
        var getState = store.getState();
        let panel: IAdminToolPanel = AdminToolPanelHelper.GetPanel(getState.adminToolState, panelName);
        AdminToolPanelHelper.SetPanelIsLoading(panelName, true);
        AdminToolHelper.ValidateJourneyGuids(items).then((response) => {
            let listJourneyItem: IJourneyItem[] = [];

            response.invalidGuids.forEach(item => {
                AdminToolPanelHelper.AddErrorMessagesToState(panel, "Unable to rollback the journey id:" + item + " because it does not exist in crm.")
            });

            response.validJourneys.forEach(item => {
                let selectJourney: IJourneyItem = journeys.filter(a => a.journeyId == item.journeyId)[0];
                listJourneyItem.push({ journeyId: item.journeyId, journeyName: item.journeyName, upgradeId: selectJourney.upgradeId, version: selectJourney.version, upgradeStatus: 'Pending Rollback' });
            });

            if (listJourneyItem) {
                AdminToolHelper.AddToProccessList(listJourneyItem);
            }
            AdminToolPanelHelper.SetPanelIsLoading(panelName, false);

        }, (error) => {
            AdminToolPanelHelper.AddErrorMessagesToState(panel, "Failed to add journeys to the journey list.Please try again.");
            AdminToolPanelHelper.SetPanelIsLoading(panelName, false);
        });
    }


    /**
    *  Update the process item
    * @static
    * @memberOf AdminToolHelper
    */
    public static UpdateProcessItem(key: string, status: string) {
        store.dispatch({
            type: types.UPDATE_PROCESS_ITEM,
            key: key,
            status: status
        });
    }

    /**
     *  Clear the process list state
     * @static
     * @memberOf AdminToolHelper
     */
    public static ClearProcessList() {
        store.dispatch({
            type: types.CLEAR_DOWN_PROCESS_UPGRADE_STATE
        });
    }
    /**
     *  Clear the upgrade state
     * @static
     * @memberOf AdminToolHelper
     */
    public static ClearUpgradeState() {
        store.dispatch({
            type: types.CLEAR_DOWN_UPGRADE_STATE,
        });
    }

    /**
     *  Set the tab in state
     * @static
     * @memberOf AdminToolHelper
     */
    public static SetTab(value: any) {
        store.dispatch({
            type: types.TOOL_SET_TAB,
            tab: value
        });
    }


    /**
    *  Bulk Import - format and display invalid guid error messages
    * @static
    * @memberOf AdminToolHelper
    */
    public static DisplayBulkMessages(invalidGuids: string[], duplicatesIds: string[], panel: IAdminToolPanel) {
        if (invalidGuids.length > 0 || duplicatesIds.length > 0) {
            let invalidGuidMessage: any = invalidGuids.map((value: string, index: number) => {
                return "\n" + value
            });

            let duplicatesinvalidGuidMessage: any = duplicatesIds.map((value: string, index: number) => {
                return "\n" + value
            })

            AdminToolPanelHelper.AddErrorMessagesToState(panel, "Invalid Value:" + invalidGuidMessage + "\n Duplicate guids:" + duplicatesinvalidGuidMessage)
        }
    }

    /**
    *  Bulk Import - Validate the text to make sure it contains valid guids
    * @static
    * @memberOf AdminToolHelper
    */
    public static CheckGuidsTextArea(textArea: any, panel: IAdminToolPanel) {
        let splitGuids: string[] = textArea.split(",");
        let invalidGuids: string[] = [];
        let arrayCount: number = 0;
        let duplicatesIds: string[] = [];

        splitGuids.forEach(guid => {
            guid = guid.trim();
            let find: string[] = splitGuids.filter(a => a.trim() == guid);
            if (find.length != 1) {
                if (duplicatesIds.filter(a => a == guid).length == 0) {
                    duplicatesIds.push(guid)
                }
            }
            if (!IdHelper.isValidGuid(guid)) {

                invalidGuids.push(guid)
            }

            arrayCount++;
        });
        if (invalidGuids.length == 0 && duplicatesIds.length == 0) {
            AdminToolHelper.ValidateJourneyGuids(splitGuids).then(
                (result: any) => {
                    AdminToolHelper.DisplayBulkMessages(result.invalidGuids, duplicatesIds, panel)
                },
                (error: any) => {
                    AdminToolPanelHelper.AddErrorMessagesToState(panel, "Failed to validate guids.Please try again.");
                });
        }
        else {
            AdminToolHelper.DisplayBulkMessages(invalidGuids, duplicatesIds, panel)
        }
    }

    /**
    * Send request to server to validate that journey ids exists
    * @static
    * @memberOf AdminToolHelper
    */
    public static ValidateJourneyGuids(journeyGuids: string[]): Promise<any> {
        let promise = new Promise<any>((resolve, reject) => {
            checkJourneyIds(journeyGuids).then(
                (response) => {

                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });

        return promise;
    }

    /**
     * Get admin tool version from the server
     * @static
     * @memberOf AdminToolHelper
     */
    public static getAdminToolVersion(): Promise<any> {
        this.SetAdminToolSetting(null, "Loading...");
        //store error
        let promise = new Promise<any>((resolve, reject) => {
            getAdminToolVersion().then(
                (response) => {
                    this.SetAdminToolSetting(null, response.version);
                    jQuery('<span class="admintool-version">' + response.version + '</span>').last().insertAfter(jQuery(".ms-Pivot button").last());
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });

        return promise;
    }

    /**
     *  add a journey to the process list 
     * @static
     * @memberOf AdminToolHelper
     */
    public static AddToProccessList(journeyItem: IJourneyItem[]) {
        store.dispatch({
            type: types.UPDATE_PROCESS_LIST,
            item: journeyItem
        });
    }

    /**
     *  add a journey to the process list 
     * @static
     * @memberOf AdminToolHelper
     */
    public static AddJESettingToProccessList(jesettingsListData: JESettingsListData[]) {
        store.dispatch({
            type: types.UPDATE_PROCESS_LIST,
            item: jesettingsListData
        });
    }

    /**
    *  set jesetting success value 
    * @static
    * @memberOf AdminToolHelper
    */
    public static SetJESettingsSidebarSuccess(value: boolean) {
        store.dispatch({
            type: types.SET_JESETTINGS_SIDEBAR_SUCCESS,
            sidebarIsSuccess: value,
        });
    }

    /**
    *  set jesetting success value 
    * @static
    * @memberOf AdminToolHelper
    */
    public static SetJESettingsSidebarError(value: string) {
        store.dispatch({
            type: types.SET_JESETTINGS_SIDEBAR_ERROR,
            sidebarError: value,
        });
    }

    /**
*  Set jesetting form validation error
* @static
* @memberOf AdminToolPanelHelper
*/
    public static SetSidebarFormValidationError(missingFields: string[]) {
        store.dispatch({
            type: types.SET_JESETTINGS_SIDEBAR_FORM_VALIDATION_ERROR,
            sidebarFormValidationError: missingFields
        });
    }


    /**
    *  set jesetting to sidebar 
    * @static
    * @memberOf AdminToolHelper
    */
    public static SetJESettingsToSidebar(jesetting: JESettingsListData) {
        let sidebar: IJESettingsSidebar = { isOpen: true, type: "edit", jesetting: jesetting, isSuccess: false, formValidationError: [], error: null };
        store.dispatch({
            type: types.SET_JESETTINGS_SIDEBAR,
            sidebar: sidebar,
        });
    }

    public static resetJourneyEngineSettingsList = () => {
        store.dispatch({
            type: types.SET_JESETTINGS_SIDEBAR_JESETTING,
            jesetting: null,
        });
    }


    /**
    *  remove a journey from the process list 
    * @static
    * @memberOf AdminToolHelper
    */
    public static RemoveToProcessList(key: string) {
        store.dispatch({
            type: types.REMOVE_PROCESS_LIST,
            item: key
        });
    }

    /**
    * Get journey by term
    * @static
    * @memberOf AdminToolHelper
    */
    public static GetJourneyByTerms(processList: any, searchTerm: string, isForSearch: boolean = true, eJourneyToolSearchType: EJourneyToolSearchType = null): Promise<any> {
        let promise = new Promise<any>((resolve, reject) => {

            if (!searchTerm.length && isForSearch) {

                store.dispatch({
                    type: types.SET_UPGRADE_JOURNEYS_SEARCH,
                    upgradeJourneysResults: [],
                    searchTerm: searchTerm
                });

                resolve([]);
            }
            else {
                getJourneysByTerm(searchTerm, eJourneyToolSearchType).then(
                    (response) => {

                        if (isForSearch) {
                            if (response) {
                                response.forEach(journey => {
                                    journey.existInProcessList = (processList.filter(a => a.journeyId === journey.journeyId)[0]) ? true : false;
                                });
                            }

                            store.dispatch({
                                type: types.SET_UPGRADE_JOURNEYS_SEARCH,
                                upgradeJourneysResults: response,
                                searchTerm: searchTerm
                            });
                        }

                        resolve(response);
                    },
                    (error) => {
                        reject(error);
                    }
                );

            }

        });
        return promise;
    }

    /**
    * Set the page mode in the state
    * @static
    * @memberOf AdminToolHelper
    */
    public static SetPageMode(pageMode: string) {
        store.dispatch({
            type: types.SET_PAGE_MODE,
            mode: pageMode
        });
    }

    /**
     * Send the query to server and get list of journeys.
     * @static
     * @memberOf AdminToolHelper
     */
    public static QueryByFetch(text: string, panelName: string, journeyToolSearchType: EJourneyToolSearchType): Promise<any> {

        let promise = new Promise<any>((resolve, reject) => {
            queryByFetch(text, journeyToolSearchType).then(
                (response) => {
                    let getState: any = store.getState();
                    let panel: IAdminToolPanel = AdminToolPanelHelper.GetPanel(getState.adminToolState, panelName);
                    if (response.error) {
                        AdminToolPanelHelper.AddErrorMessagesToState(panel, response.error.message)
                    }
                    else {
                        let listJourneyItem: IJourneyItem[] = [];
                        response.data.forEach(fieldValue => {
                            listJourneyItem.push({ journeyId: fieldValue.py3ip_journeyid, version: fieldValue.py3ip_journeyversion, journeyName: fieldValue.py3ip_name, upgradeStatus: '' })
                        });
                        AdminToolHelper.AddToProccessList(listJourneyItem);
                    }
                    AdminToolPanelHelper.SetPanelIsLoading(panel.panelName, false);
                    resolve(response);
                },
                (error) => {
                    let getState: any = store.getState();
                    let panel: IAdminToolPanel = AdminToolPanelHelper.GetPanel(getState.adminToolState, panelName);
                    AdminToolPanelHelper.AddErrorMessagesToState(panel, "Failed to fetch journeys. Please try again.")
                    reject(error);
                }
            );
        });

        return promise;
    }

    /**
    * List of upgrades
    * @static
    * @memberOf AdminToolHelper
    */
    public static getAdminToolList(panelName: any, isJESettingsList?: boolean): Promise<any> {
        let promise = new Promise<any>((resolve, reject) => {
            isJESettingsList ?
                getJourneyEngineSettingsList().then(
                    (response) => {

                        response = response.sort((a, b) => {

                            if (a.keyField.toLowerCase() < b.keyField.toLowerCase()) {
                                return -1;
                            }

                            if (a.keyField.toLowerCase() > b.keyField.toLowerCase()) {
                                return 1;
                            }

                            return 0;

                        });

                        AdminToolPanelHelper.AddOrUpdatePanelValue(panelName, PANEL_VALUE_JESETTINGS_LIST, response);
                        resolve(response);
                    },
                    (error) => {
                        reject(error);
                    }
                )
                :
                getAdminToolList().then(
                    (response) => {
                        var getState = store.getState();
                        AdminToolPanelHelper.AddOrUpdatePanelValue(panelName, PANEL_VALUE_RESULT_LIST, response);
                        resolve(response);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });

        return promise;
    }

    /**
    *  Set the upgrade state
    * @static
    * @memberOf AdminToolHelper
    */
    public static SetUpgradingProcess(isProcessing: boolean, journeyProcessingId: string, journeyNum: number) {
        store.dispatch({
            type: types.UPDATE_ISPROCESSING_STATE,
            IsProccessing: isProcessing,
            JourneyProcessingId: journeyProcessingId,
            journeyProcessNum: journeyNum,
            isUpgradingScreen: true
        });
    }
}


// WEBPACK FOOTER //
// ./source/ts/helpers/admintoolhelper.ts